const PERSON_TOKEN_JWT_KEY = 'person-jwt';
const COMPANY_CONFIGS_KEY = 'company-configs';
const COMPANY_ID_CONFIG_KEY = 'company-id-config';


export default {
  debug: true,

  state: {
    changes: [],
    baseUrls: [],
    historySummary: [],
    companySummaries: [],
    transactionsSummary: [],
    companyIds: new Set(),

    companyConfigs: [],
    companyIdConfig: {},

    companyIdAccessToken: {},

    companyHistoryMap: {},
    baseUrl: "https://at9vtw7qw6.execute-api.us-east-1.amazonaws.com/dev",
    personToken: "",
    token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6InhwcnQifQ.eyJpbnRlZ3JhdG9yX2lkIjoiNWE1NGMzOTk1ZTYyZmQzNzVhZGJiNmVlIiwic3ViIjoiaHR0cHM6Ly9kZXYteHBydGJhY2tlbmQuaGVhcnRsYW5kY29tbWVyY2UuY29tL2ludGVncmF0b3IvZDBiNDNjYTQtMGMzNy00OGQyLWFhMmMtY2JjMzlkYzQ4OWVkIiwiaW50ZWdyYXRvcl9raWQiOiJkMGI0M2NhNC0wYzM3LTQ4ZDItYWEyYy1jYmMzOWRjNDg5ZWQiLCJjb21wYW55X2lkIjoiKiIsImF1ZCI6WyJYUFJUIiwiWFBPUyIsIlhNTyIsIlhCT0YiLCJYRE0iLCJYS1MiLCJSUFQiLCJIQlQiLCJYQ0MiLCJYUElQIl0sInRva2VuX3R5cGUiOiJpbnRlZ3JhdG9yIiwiaWF0IjoxNTMyOTYyNTcwLCJleHAiOjE1MzQ3NzY5NzAsImlzcyI6ImRldi14cHJ0YmFja2VuZC5oZWFydGxhbmRjb21tZXJjZS5jb20ifQ.K9YjWP06BpeyOWpcUC0wmZe3GEyqWf8MsOlsMGNTwp8",
    companyTransactionMap: {},
  },

  setHistories(v) {
    this.state.histories = v;
  },

  setTransactions(v) {
    this.state.transactions = v;
  },

  setChanges(v) {
    this.state.changes = v;
  },

  setBaseUrls(urls) {
    this.state.baseUrls = urls;
  },

  clearCompanyConfigs() {
    this.state.companyConfigs = [];
  },

  setCompanyConfig(companyId, config) {
    this.state.companyConfigs.push(config);
    this.state.companyIdConfig[config.companyId] = config;
  },

  getCompanyConfig(companyId) {
    return this.state.companyIdConfig[companyId];
  },

  setPersonToken(token) {
    this.state.personToken = token;

    if (window.sessionStorage) {
      sessionStorage.setItem(PERSON_TOKEN_JWT_KEY, token);
    }
  },

  getPersonToken() {
    return this.state.personToken
  },

  getToken() {
    return this.state.token
  },

  getOlBaseUrl() {
    return this.state.baseUrl
  },

  setCompanyIdAccessToken(companyId, accessToken) {
    this.state.companyIdAccessToken[companyId] = accessToken;

    if(window.sessionStorage) {
      sessionStorage.setItem(`${companyId}:access-token`, accessToken)
    }
  },

  getCompanyAccessToken(companyId) {
    let token = this.state.companyIdAccessToken[companyId];

    if (!token) {
      return sessionStorage.getItem(`${companyId}:access-token`)

    } else {
      return token
    }
  },

  setHistorySummaries(summaries) {
    this.state.historySummary.push(...summaries)
  },

  getHistorySummaries() {
    return this.state.historySummary;
  },

  setTransactionSummaries(summaries) {
    this.state.transactionsSummary.push(...summaries)
  },

  getTransactionSummaries() {
    return this.state.transactionsSummary;
  },

  setCompanySummaries(summaries) {
    this.state.companySummaries = summaries
  },

  getCompanySummary(companyId) {
    return this.state.companySummaries.filter(sum => sum.companyId === companyId)[0];
  },

  addHistories(v) {
    this.state.histories.push(...v);
  },

  addTransactions(v) {
    this.state.transactions.push(...v)
  },

  addCompanyId(v) {
    this.state.companyIds.add(v);
  },

  addCompanyHistoryMap(companyId, v) {
    if (companyId in this.state.companyHistoryMap) {
      this.state.companyHistoryMap[companyId].push(v)
    } else {
      this.state.companyHistoryMap[companyId] = [];
      this.state.companyHistoryMap[companyId].push(v)
    }
  },

  addCompanyTransactionMap(companyId, v) {
    if (companyId in this.state.companyTransactionMap) {
      this.state.companyTransactionMap[companyId].push(v)
    } else {
      this.state.companyTransactionMap[companyId] = [];
      this.state.companyTransactionMap[companyId].push(v)
    }
  },

  loadCache() {

    if (window.sessionStorage) {

      let token = sessionStorage.getItem(PERSON_TOKEN_JWT_KEY);

      if (token) {
        this.setPersonToken(token);
      }

    }
  }
}
